// extracted by mini-css-extract-plugin
export default {"homeCategoryTagsWrapper":"styles_homeCategoryTagsWrapper__u9D-e","homeCategoryTag":"styles_homeCategoryTag__b2QYK"};